import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const usePerspectiveCardStyles = makeThemedStyles(
  "PerspectiveCard",
  (theme) => ({
    root: {
      width: "30.4em",
      minHeight: "37.1em",
      fontSize: "10px",
      borderRadius: ".8em",
      border: "1px solid rgba(247, 247, 247, 1)",

      background:
        "linear-gradient(0deg, rgba(225, 245, 255, 0) 0%, #E1F5FF 100%)",
      padding: "20px",
    },
  })
);

export const PerspectiveCard = React.memo(
  (props: React.PropsWithChildren<{}>) => {
    const styles = usePerspectiveCardStyles();

    return <div className={styles.root}>{props.children}</div>;
  }
);
